import * as React from 'react'
import { t } from 'ttag'
import { ReactComponent as LogOutIcon } from '../../../assets/v2/icons/log-out.svg'
import { ReactComponent as UserDropdownIcon } from '../../../assets/v2/icons/icon-user-dropdown.svg'
import { IRoute } from '../../../common/Routes/routePaths'
import { Initials } from '../../Initials/Initials'
import { YNavLink } from '../../YNavLink/YNavLink'
import './NavProfile.scss'

interface INavProfileProps {
  fullName: string
  routes?: IRoute[]
  isProfileOpen?: boolean
  toggleProfileDropdown?(): void
  onLogout?(): void
}

export interface INavProfileState {
  isOpen: boolean
}

export class NavProfile extends React.PureComponent<INavProfileProps, INavProfileState> {
  state = {
    isOpen: false,
  }

  dropdownBEM = () => {
    const classArray = ['nav-profile__dropdown']

    if (this.props.isProfileOpen) {
      classArray.push('nav-profile__dropdown--open')
    }

    return classArray.join(' ')
  }

  render() {
    const { fullName, routes, toggleProfileDropdown, onLogout, isProfileOpen } = this.props

    return (
      <div className="nav-profile">
        <button type="button" onClick={toggleProfileDropdown} className="nav-profile__toggle">
          <Initials fullName={fullName} size="lg" />
          <UserDropdownIcon className={'nav-profile__dropdown-icon'} />
          {/*<div className="nav-profile__info">
            <p className="nav-profile__name" title={fullName}>
              {fullName}
            </p>
          </div>*/}
        </button>

        <ul className={this.dropdownBEM()}>
          {routes &&
            routes.map(({ to, title, icon: Icon }) => (
              <li key={to}>
                <YNavLink to={to} className="nav-profile__link" onClick={toggleProfileDropdown}>
                  {Icon && <Icon className="nav-profile__icon" />}
                  <span>{title}</span>
                </YNavLink>
              </li>
            ))}
          <li>
            <button className="nav-profile__link" type="button" onClick={onLogout}>
              <LogOutIcon className="nav-profile__icon" />
              {t`Log out`}
            </button>
          </li>
        </ul>

        {isProfileOpen && <div className="nav-profile__backdrop" onClick={toggleProfileDropdown} />}
      </div>
    )
  }
}
